import axios from 'axios';

import IGlobalJobSearchFilterDTO from '../types/IGlobalJobSearchFilterDTO';

export const fetchHotJobs = (filter: IGlobalJobSearchFilterDTO) =>
  axios.post('/jobsearch/api/_search/global-jobs', filter);
